<script>
    import TheSvgIcon from "@main/packages/TheSvgIcon";
    import ImageResponsive from "@/components/ImageResponsive";
    import HomeInstructionTabs from "@igarden/components/HomeInstructionTabs";

    export default {
        name: "HomeInstruction",
        components: { ImageResponsive, TheSvgIcon, HomeInstructionTabs },
        data() {
            return {
                slideIndex: 1,
            };
        },
        computed: {
            slides() {
                return [
                    {
                        text: "Вскройте горшки <br> с&nbsp;вермикулитом",
                        index: 1,
                    },
                    {
                        text: "Посейте семена в&nbsp;вермикулит. Крупные&nbsp;&mdash; на&nbsp;глубину 5&nbsp;мм, мелкие оставьте на&nbsp;поверхности",
                        index: 2,
                    },
                    {
                        text: "Налейте воду в&nbsp;резервуар до&nbsp;указанного уровня",
                        index: 3,
                    },
                    {
                        text: "Поместите горшки в&nbsp;слоты в&nbsp;резервуаре",
                        index: 4,
                    },
                    {
                        text: "Если у&nbsp;сада есть лампа, установите ее&nbsp;в&nbsp;подставку. Если лампы нет, найдите хорошо освещенное место. Подключите питание и&nbsp;включите устройство",
                        index: 5,
                    },
                    {
                        text: "Следите за&nbsp;уровнем воды. Доливайте по&nbsp;необходимости",
                        index: 6,
                    },
                ];
            },
        },
        methods: {
            changeSlide(index) {
                this.slideIndex = index;
            },
            prevSlide() {
                this.slideIndex--;
                if (this.slideIndex < 1) {
                    this.slideIndex = 6;
                }
            },
            nextSlide() {
                this.slideIndex++;
                if (this.slideIndex > 6) {
                    this.slideIndex = 1;
                }
            },
        },
    };
</script>

<template>
    <section class="home-instruction" id="instructions">
        <h2 class="home-instruction__title page-title">Как пользоваться умным садом</h2>
        <div class="home-instruction__inner">
            <div class="home-instruction__arrows mobile-hidden">
                <button
                    class="home-instruction__arrow home-instruction__arrow--prev outline"
                    @click="prevSlide"
                >
                    <the-svg-icon name="arrow" :size-w="24"></the-svg-icon>
                </button>
                <button
                    class="home-instruction__arrow home-instruction__arrow--next outline"
                    @click="nextSlide"
                >
                    <the-svg-icon name="arrow" :size-w="24"></the-svg-icon>
                </button>
            </div>

            <div class="home-instruction__main">
                <div class="home-instruction__tabs">
                    <home-instruction-tabs
                        :current="slideIndex"
                        :end="6"
                        @on-change="changeSlide"
                    ></home-instruction-tabs>
                </div>
                <div class="home-instruction__content">
                    <div
                        class="home-instruction__text-track"
                        :style="{
                            transform: `
                                translateX(-${((slideIndex - 1) * 100) / slides.length}%)
                            `,
                        }"
                    >
                        <div
                            class="home-instruction__text"
                            v-for="slide in slides"
                            :key="slide.index"
                            v-html="slide.text"
                        ></div>
                    </div>
                </div>
            </div>

            <div class="home-instruction__image-inner">
                <transition name="fade" v-for="slide in slides" :key="slide.index">
                    <div class="home-instruction__image" v-if="slide.index === slideIndex">
                        <image-responsive
                            :mobile="`/static/igarden/home/instruction/${slide.index}--m.jpg`"
                            :mobile-webp="`/static/igarden/home/instruction/${slide.index}--m.webp`"
                            :desktop="`/static/igarden/home/instruction/${slide.index}.jpg`"
                            :desktop-webp="`/static/igarden/home/instruction/${slide.index}.webp`"
                            breakpoint="600"
                        ></image-responsive>
                    </div>
                </transition>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    .home-instruction__title {
        margin-bottom: 16px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 24px;
        }
    }

    .home-instruction__inner {
        position: relative;
        padding: 24px;
        border-radius: var(--border-md);
        box-shadow: var(--primary-shadow);
        @include bp($bp-desktop-sm) {
            display: flex;
            padding: 48px 72px;
            border-radius: var(--border-xl);
        }
    }

    .home-instruction__arrows {
        @include bp($bp-desktop-sm) {
            position: absolute;
            z-index: 10;
            top: 50%;
            left: 24px;
            right: 24px;
            display: flex;
            justify-content: space-between;
            transform: translateY(-50%);
        }
    }

    .home-instruction__arrow {
        display: flex;
        justify-content: center;
        align-items: center;
        @include box(36px);
        border-radius: 50%;
        svg {
            fill: var(--primary--dark);
        }
    }

    .home-instruction__arrow--next {
        svg {
            transform: scale(-1);
        }
    }

    .home-instruction__main {
        display: flex;
        flex-direction: column;
        align-self: flex-end;

        @include bp($bp-desktop-sm) {
            flex-basis: calc(45% - 80px);
            max-width: calc(45% - 80px);
            margin-right: 80px;
        }
    }

    .home-instruction__content {
        margin-bottom: 12px;
        overflow: hidden;
        @include bp($bp-desktop-sm) {
            margin-bottom: 0;
        }
    }

    .home-instruction__image-inner {
        @include responsive-box(53%);
        @include bp($bp-desktop-sm) {
            flex-basis: 55%;
            max-width: 55%;
        }
    }

    .home-instruction__image {
        --transition-duration: 0.7s;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: var(--primary);
        border-radius: var(--border-lg);
        overflow: hidden;
        @include bp($bp-desktop-sm) {
            border-radius: 30px;
        }
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            pointer-events: none;
        }
    }

    .home-instruction__tabs {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
        @include bp($bp-desktop-sm) {
            order: 1;
            margin-bottom: 0;
        }
    }

    .home-instruction__text-track {
        display: flex;
        align-items: center;
        width: 600%;
        transition: transform 0.3s ease-in;
        overflow: hidden;
        @include bp($bp-desktop-sm) {
            margin-bottom: 42px;
        }
    }

    .home-instruction__text {
        max-width: 230px;
        width: 100%;
        margin: 0 auto;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        @include bp($bp-desktop-sm) {
            max-width: 100%;
            font-size: 24px;
            line-height: 38px;
        }
    }
</style>
